import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { setPage as setPageAction } from '../../actions/SiteActions';
import { loadPage } from '../../lib/request';

// import * as AppPropTypes from '../../lib/PropTypes';
import PageMeta from '../partials/PageMeta';
import Article from '../partials/Article';

import styles from '../../../styles/pages/article.scss';

const messages = defineMessages({
    metaTitle: {
        id: 'meta.title',
        defaultMessage: 'Title',
    },
});

const propTypes = {
    setPage: PropTypes.func.isRequired,
    article: PropTypes.object, // eslint-disable-line
};

const defaultProps = {
    article: {},
};

const ArticlePage = ({ setPage, article }) => {
    useEffect(() => {
        loadPage().then(screenings => {
            setPage(screenings);
        });
    }, []);

    return (
        <div className={styles.container}>
            <PageMeta title={messages.metaTitle} />
            <Article article={article} className={styles.article} />
        </div>
    );
};

ArticlePage.propTypes = propTypes;
ArticlePage.defaultProps = defaultProps;

const WithStateContainer = connect(
    ({ site: { page } }) => ({
        article: page,
    }),
    dispatch => ({
        setPage: page => dispatch(setPageAction(page)),
    }),
)(ArticlePage);

export default WithStateContainer;
